import * as React from 'react';
import { Divider, withStyles, WithStyles } from '@material-ui/core';

import styles from './AppointmentItemDivider.styles';

interface IAppointmentItemDivider extends WithStyles<typeof styles> {}

const AppointmentItemDivider = (props: IAppointmentItemDivider) => {
  const { classes } = props;

  return <Divider className={classes.divider} />;
};

export default withStyles(styles)(AppointmentItemDivider);
